import Field from "./Field";

class JsonField extends Field {
    constructor(name) {
        super(name);
        this._type = "json";
        this._flattenable = false;
    }
}

export default JsonField;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/Field/JsonField.js
 **/